export default "__VITE_ASSET__BWkIV0to__"